import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { Spinner } from "pro-features/components/Loaders/src/Spinner";
import { MetricContainer } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";

import { DataRowTitle } from "../components/datarow/DataRowStyledComponents";

const { carbon, torquoise } = colorsPalettes;

export const SerpCompositionMetricContainerStyled = styled(MetricContainer)<{ aiExistence: boolean }>`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 426px;
    border-right: 1px solid ${carbon[50]};
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: -2px 3px 6px 0 rgba(14, 30, 62, 0.08);
    ${DataRowTitle} {
        margin-bottom: ${({ aiExistence }) => (aiExistence ? "20px" : "48px")};
    }
    .non-selectable-legends-wrapper {
        align-items: flex-end;
    }
`;

export const AiOverview = styled(Flex)`
    background-color: ${torquoise[50]};
    border-radius: 4px;
    padding: 12px 16px;
    gap: 8px;
    margin-bottom: 24px;
`;

export const LoadingSpinner = styled(Spinner)<{ top?: string }>`
    margin: 0 auto;
    position: relative;
    top: ${({ top }) => (top ? top : "40px")};
    width: 55px;
    height: 55px;
`;

export const LegendComponentWrapper = styled.div`
    width: 220px;
    display: flex;
    justify-content: space-between;
`;
